import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '../views/login/Auth.vue'
import store from '../store'
import {
	getRoleSectionName,
	isPublicRoute,
	buildLoginHashUrl,
	getDefaultRouteForRole,
	getRoleHomeRouteName,
	getLoginReturnPath,
} from './utils'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: () => getDefaultRouteForRole(store.getters.getCurrentRole),
	},
	{
		path: '/login',
		component: Auth,
		meta: { public: true },
		beforeEnter(to, from, next) {
			const role = store.getters.getCurrentRole;
			if (store.getters.getAccessToken && role) {
				const homeRoute = getRoleHomeRouteName(role);
				next(homeRoute ? { name: homeRoute } : { name: role });
				return;
			}
			next();
		},
		children: [
			{
				path: ':user',
				component: Auth,
			},
		],
	},
	// ТиПО
	// {
	// 	path: '/department',
	// 	name: 'department',
	// 	redirect: { name: 'main' },
	// 	component: () => import('../views/department/DepartmentLayoutView.vue'),
	// 	children: [
	// 		{
	// 			path: 'main',
	// 			alias: '',
	// 			name: 'main',
	// 			component: () => import('../views/department/MainDashboard.vue'),
	// 		},
	// 		{
	// 			path: 'colleges',
	// 			component: () => import('../views/department/CollegeDashboard.vue'),
	// 		},
	// 		{
	// 			path: 'colleges/:bin',
	// 			component: () => import('../views/department/CollegeViewDashboard.vue'),
	// 		},
	// 		{
	// 			path: 'monitoring',
	// 			component: () => import('../views/department/MonitoringDashboard.vue'),
	// 		},
	// 	],
	// 	beforeEnter(to, from, next) {
	// 		store.dispatch('changeBaseUrl');
	// 		next();
	// 	},
	// },

	{
		path: '/college',
		name: 'college',
		redirect: { name: 'places' },
		component: () => import('../views/college/CollegeView.vue'),
		children: [
			{
				path: 'places',
				alias: '',
				name: 'places',
				component: () => import('../views/college/PlaceListView.vue'),
			},
			{
				path: 'requests/statistics',
				component: () => import('../views/college/OrderRequestsStatisticsView.vue'),
			},
			// {
			// 	path: 'requests/undeveloped-places-request',
			// 	name: 'college-new-undeveloped',
			// 	component: () => import('../views/college/NewRequestUndevelopedPlacesView.vue'),
			// },
			{
				path: 'requests/request-new',
				name: 'college-new-request',
				component: () => import('../views/college/NewRequestView.vue'),
			},
			{
				path: 'requests/request-targeted-grant',
				name: 'college-new-targeted-grant',
				component: () => import('../views/college/NewRequestTargetedGrantView.vue'),
			},
			{
				path: 'requests/order-management',
				name: 'college-order-management',
				component: () => import('../views/college/CollegeOrderManagementView.vue'),
			},
			{
				path: 'requests',
				component: () => import('../views/college/OrderRequestsListView.vue'),
			},
			{
				path: 'requests/:filter',
				component: () => import('../views/college/OrderRequestsListView.vue'),
			},
			{
				path: 'request/:id',
				component: () => import('../views/college/OrderRequestView.vue'),
			},
			{
				path: 'profile',
				component: () => import('../views/college/ProfileView.vue'),
			},
			// {
			// 	path: 'news',
			// 	component: () => import('../views/college/NewsListView.vue'),
			// },
			// {
			// 	path: 'virtual-blogs/:filter',
			// 	component: () => import('../views/college/VirtualBlogsListView.vue'),
			// },
			// {
			// 	path: 'virtual-blogs',
			// 	component: () => import('../views/college/VirtualBlogsListView.vue'),
			// },
			{
				path: 'occupancy',
				component: () => import('../views/college/OccupancyListView.vue'),
			},
			{
				path: 'acs-settings',
				component: () => import('../views/college/AcsSettingsView.vue'),
			},
			{
				path: 'rating',
				component: () => import('../views/college/RatingListView.vue'),
			},
			{
				path: 'preliminary',
				component: () => import('../views/college/PreliminaryListView.vue'),
			},
		],
		beforeEnter(to, from, next) {
			store.dispatch('changeBaseUrl');
			next();
		},
	},
	{
		path: '/abiturient',
		name: 'abiturient',
		redirect: { name: 'abiturient-home' },
		component: () => import('../views/abiturient/AbiturientLayoutView.vue'),
		children: [
			{
				path: '',
				name: 'abiturient-home',
				component: () => import('../views/abiturient/AbiturientHomeView.vue'),
			},
			{
				path: 'my-requests',
				name: 'abiturient-my-requests',
				component: () => import('../views/abiturient/MyRequestListView.vue'),
			},
			{
				path: 'my-requests/new',
				name: 'abiturient-new-request',
				component: () => import('../views/abiturient/NewRequestView.vue'),
			},
			{
				path: 'my-requests/parent',
				name: 'abiturient-parent-request',
				component: () => import('../views/abiturient/ParentRequestView.vue'),
			},
			{
				path: 'my-requests/children',
				name: 'abiturient-children',
				component: () => import('../views/abiturient/ParentChildrenListView.vue'),
			},
			{
				path: 'my-requests/:id(\\d+)/edit',
				name: 'abiturient-request-edit',
				component: () => import('../views/abiturient/EditRequestView.vue'),
			},
			{
				path: 'my-requests/:id(\\d+)',
				name: 'abiturient-request',
				component: () => import('../views/abiturient/MyRequestView.vue'),
			},
			// {
			// 	path: 'virtual-blogs',
			// 	name: 'abiturient-virtual-blogs',
			// 	component: () => import('../views/abiturient/MyVirtualBlogsView.vue'),
			// },
		],
		beforeEnter(to, from, next) {
			store.dispatch('changeBaseUrl');
			next();
		},
	},
	{
		path: '*',
		redirect: () => getDefaultRouteForRole(store.getters.getCurrentRole),
	},
]

const router = new VueRouter({
	routes,
})

router.beforeEach((to, from, next) => {
	const role = store.getters.getCurrentRole;
	const sectionName = getRoleSectionName(to);

	if (!isPublicRoute(to) && !store.getters.getAccessToken) {
		location.href = buildLoginHashUrl(getLoginReturnPath(to.fullPath, sectionName), sectionName);
		location.reload();
		return;
	}

	if (!isPublicRoute(to) && role && sectionName && sectionName !== role) {
		const homeRoute = getRoleHomeRouteName(role);
		next(homeRoute ? { name: homeRoute } : { name: role });
		return;
	}

	next();
});

export default router
